import { createSlice } from "@reduxjs/toolkit";

 const pdfData = createSlice({
    name : 'pdf',
    initialState:{
        getData: null,
    },
    reducers:{
    setPDFData(state, action){
        console.log(action.payload)
        state.getData = action.payload
    },
    resetData(state){
        state.getData = null
    }
    }
})

export const { setPDFData, onPrint, resetData } = pdfData.actions
export default pdfData.reducer
